// extracted by mini-css-extract-plugin
export default {"arrival-time":"style_arrival-time__EeKrO","container-edit":"style_container-edit__Xmtye","bt-edit":"style_bt-edit__aXpgq"};